/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createCustomerHealthFromDiscriminatorValue, createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, type CustomerHealth, type ErrorResponse, type InternalErrorResponse } from '../../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/analytics/customers/health
 */
export interface HealthRequestBuilder extends BaseRequestBuilder<HealthRequestBuilder> {
    /**
     * Every active customer placed by how long ago they last ordered: active (under 90 days), cooling (90 to 180), at risk (180 to 365) and lapsed (a year or more, or never ordered). The four counts add up to the active customer total. "Worth a call" lists the quiet accounts most worth chasing — no order in 180 days or more but still buying in the last year — biggest trailing-year revenue first, each with the assigned rep (by rep number) and payment terms. Customers are matched to their orders by customer number, ignoring case. Figures may be up to a few minutes old.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<CustomerHealth>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     get(requestConfiguration?: RequestConfiguration<HealthRequestBuilderGetQueryParameters> | undefined) : Promise<CustomerHealth | undefined>;
    /**
     * Every active customer placed by how long ago they last ordered: active (under 90 days), cooling (90 to 180), at risk (180 to 365) and lapsed (a year or more, or never ordered). The four counts add up to the active customer total. "Worth a call" lists the quiet accounts most worth chasing — no order in 180 days or more but still buying in the last year — biggest trailing-year revenue first, each with the assigned rep (by rep number) and payment terms. Customers are matched to their orders by customer number, ignoring case. Figures may be up to a few minutes old.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<HealthRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
}
/**
 * Every active customer placed by how long ago they last ordered: active (under 90 days), cooling (90 to 180), at risk (180 to 365) and lapsed (a year or more, or never ordered). The four counts add up to the active customer total. "Worth a call" lists the quiet accounts most worth chasing — no order in 180 days or more but still buying in the last year — biggest trailing-year revenue first, each with the assigned rep (by rep number) and payment terms. Customers are matched to their orders by customer number, ignoring case. Figures may be up to a few minutes old.
 */
export interface HealthRequestBuilderGetQueryParameters {
    /**
     * How many quiet accounts to list under "worth a call". Defaults to 5; at most 20.
     */
    limit?: number;
}
/**
 * Uri template for the request builder.
 */
export const HealthRequestBuilderUriTemplate = "{+baseurl}/api/analytics/customers/health?limit={limit}";
/**
 * Metadata for all the requests in the request builder.
 */
export const HealthRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: HealthRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createCustomerHealthFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
